<template>
    <article class="border border-amber-300 bg-amber-50 px-2 py-1.5 text-slate-800"
             data-admin2026-training-plan-quick-preview-checkpoint="true">
        <div class="flex min-w-0 items-center gap-1.5">
            <i :class="checkpoint.type === 'questionnaire' ? 'fa-solid fa-list-check' : 'fa-solid fa-stopwatch'"
               class="shrink-0 text-[9px] text-amber-700"
               aria-hidden="true"></i>
            <span class="min-w-0 truncate text-[10px] font-bold" v-text="checkpoint.title || 'Untitled checkpoint'"></span>
            <span class="shrink-0 bg-amber-200 px-1.5 py-0.5 text-[8px] font-bold uppercase tracking-wide text-amber-900"
                  v-text="typeLabel"></span>
            <span v-if="checkpoint.required" class="shrink-0 text-[8px] font-semibold text-amber-800">Required</span>
            <span class="ml-auto shrink-0 text-[8px] font-semibold text-slate-500" v-text="timingLabel"></span>
        </div>

        <p v-if="plainText(checkpoint.instructions)"
           class="mt-1 truncate text-[9px] leading-3 text-slate-600"
           data-admin2026-training-plan-quick-preview-description="true"
           v-text="plainText(checkpoint.instructions)"></p>

        <div v-if="fields.length" class="mt-1 flex min-w-0 flex-wrap gap-x-2 gap-y-0.5 text-[8px] leading-3 text-slate-600">
            <span class="font-bold text-slate-700" v-text="checkpoint.type === 'questionnaire' ? 'Questions:' : 'Test results:'"></span>
            <span v-for="(field, fieldIndex) in fields"
                  :key="'quick-preview-checkpoint-field-'+String(field.id || field.client_key || fieldIndex)"
                  class="min-w-0"
                  v-text="fieldSummary(field)"></span>
        </div>

        <div v-if="checkpoint.gates_future_training"
             class="mt-1 flex flex-wrap gap-x-2 text-[8px] font-semibold text-slate-500">
            <span>Holds future training</span>
        </div>
    </article>
</template>

<script>
export default {
    name: 'TrainingPlanQuickPreviewCheckpoint',
    props: {
        checkpoint: {
            type: Object,
            required: true,
        },
        timingLabel: {
            type: String,
            default: 'Checkpoint',
        },
        typeLabel: {
            type: String,
            default: 'Checkpoint',
        },
        responseTypes: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        fields()
        {
            return Array.isArray(this.checkpoint.fields) ? this.checkpoint.fields : [];
        },
    },
    methods: {
        plainText(value)
        {
            if (value === null || typeof value === 'undefined') return '';

            const container = document.createElement('div');
            container.innerHTML = String(value).replace(/<br\s*\/?>/gi, '\n');

            return (container.textContent || container.innerText || '').replace(/\s+/g, ' ').trim();
        },
        fieldSummary(field)
        {
            const label = String((field && field.label) || '').trim() || 'Unnamed item';
            const responseType = this.responseTypes[String((field && field.response_type) || '')] || '';
            const unit = String((field && field.unit) || '').trim();
            const details = [responseType, unit].filter(value => value !== '').join(', ');

            return details ? label + ' (' + details + ')' : label;
        },
    },
};
</script>
